import { render, staticRenderFns } from "./buyDetail.vue?vue&type=template&id=5ec5c87a&scoped=true"
import script from "./buyDetail.vue?vue&type=script&lang=js"
export * from "./buyDetail.vue?vue&type=script&lang=js"
import style0 from "./buyDetail.vue?vue&type=style&index=0&id=5ec5c87a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec5c87a",
  null
  
)

export default component.exports